import { Pipe, PipeTransform } from '@angular/core';
import { Request } from '../../classes/request';

@Pipe({
  name: 'progressStatusFilter',
  pure: false
})
export class ProgressStatusFilterPipe implements PipeTransform {

  transform(requestList: Array<Request>, filterValues: string[]): any {
    if (!requestList || !filterValues?.length) {
      return requestList;
    }

    const normalizedFilters = new Set(filterValues.map(value => value.toLowerCase()));
    return requestList.filter(request => normalizedFilters.has(this.resolveStatusLabel(request)));
  }

  private resolveStatusLabel(request: Request): string {
    if (request.ProgressStatus < 9) {
      return 'in fase di compilazione';
    }
    if (request.ProgressStatus === 9 && !request.CompanyParticipation && !request.PartnersParticipation) {
      return 'da convalidare';
    }
    if (request.ProgressStatus === 9 && (request.CompanyParticipation || request.PartnersParticipation)) {
      return 'da controllare';
    }
    if (request.ProgressStatus === 10) {
      return 'completato';
    }
    return '';
  }

}
